module.exports = __webpack_public_path__ + "static/media/musical_nodes.b9ee2e25.png";